export const CountryCodes = [
  { label: "United States (+1)", value: "US" },
  { label: "Canada (+1)", value: "CA" },
];

export const LeadAssignInfo = {
  first_to_claim: {
    description: (
      <span>
        {`${"When a new lead comes in, all agents below will be called with the lead's basic information. The first one to hit 1 will claim the lead."}`}
      </span>
    ),
    pretty: "First To Claim",
    fallbackOptions: {
      voicemail: {
        description: (
          <span>
            {`${"Note: If a lead is created from a missed call, it will follow your default lead routing rules or you can set up a rule based on this tracking number's source. "}`}
          </span>
        ),
        pretty: "go to voicemail",
      },
      call_individual: {
        description: (
          <span>
            {`${"Note: If a lead is created from a missed call, it will follow your default lead routing rules or you can set up a rule based on this tracking number's source. "}`}
          </span>
        ),
        pretty: "call individual",
      },
    },
  },
  round_robin: {
    description: (
      <span>
        {`${"When a new lead comes in, they will be distributed to the following agents in order."}`}
      </span>
    ),
    pretty: "Round Robin",
    fallbackOptions: {
      dial_next: {
        description: (
          <span>
            {`${"Note: If a lead is created from a missed call, it will follow your default lead routing rules or you can set up a rule based on this tracking number's source. "}`}
          </span>
        ),
        pretty: "Dial next agent in round robin",
      },
      voicemail: {
        description: null,
        pretty: "go to voicemail",
      },
    },
  },
};

export const CallRecordingInfo = {
  inboundRecording: {
    disabled: {
      pretty: "Disable Recording",
    },
    automatic: {
      pretty: "Record Automatically",
    },
  },
  inboundNotificationMessageCondition: {
    always: {
      pretty: "Always Play",
    },
    check: {
      pretty: "Check Location",
    },
  },
};
